import * as React from 'react';

export default props => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <g
            fill='none'
            fillRule='evenodd'
        >
            <path
                fill='none'
                d='M0 0h24v24H0z'
            />
            <path
                fill='#DF4930'
                d='M12.169 9.624v4.752s4.675-.006 6.578-.006c-1.03 3.081-2.633 4.759-6.578 4.759-3.993 0-7.109-3.192-7.109-7.129 0-3.937 3.116-7.129 7.109-7.129 2.11 0 3.474.732 4.724 1.752 1.001-.987.918-1.128 3.464-3.5A12.22 12.22 0 0 0 12.17 0C5.449 0 0 5.373 0 12s5.448 12 12.169 12c10.045 0 12.5-8.626 11.686-14.376H12.17z'
            />
        </g>
    </svg>
)
